export const getExtFromFilePath = (filepath: string): string => {
  return filepath.split('/').reverse()[0].split('.')[1];
};
